import isEqual from 'fast-deep-equal';
export default isEqual;
//# sourceMappingURL=isEqual.js.map